/**
 * Combined regex for single-pass sanitization.
 * Group 1: API keys (AIza...)
 * Group 2: Path prefixes (C:\Users\ or /Users/)
 * The 'i' flag is used for case-insensitive path matching;
 * case-sensitivity for API keys is handled in the replacement callback.
 */
const SANITIZE_REGEX =
	/(AIza[0-9A-Za-z-_]{35,})|((?:C:\\Users\\|\/Users\/))[^\\/]+/gi;

/**
 * Sanitizes strings by masking sensitive information like API keys and local paths.
 */
export function sanitize(input: string): string {
	if (!input || typeof input !== "string") {
		return input;
	}

	// Performance optimization: Consolidated from 2 passes to 1 pass using a combined regex.
	// This reduces string scans and minimizes intermediate string allocations,
	// which is especially beneficial for large inputs like stack traces or full transcripts.
	return input.replace(SANITIZE_REGEX, (match, apiKey, pathPrefix) => {
		// Handle API Key (Group 1)
		// Original pattern was case-sensitive, so we verify the prefix.
		if (apiKey) {
			if (apiKey.startsWith("AIza")) {
				return "AIza...[MASKED]";
			}
			// If it matched due to 'i' flag but doesn't start with 'AIza', don't mask.
			return match;
		}

		// Handle Path (Group 2)
		// Original pattern was case-insensitive, handled by the 'i' flag on SANITIZE_REGEX.
		if (pathPrefix) {
			return `${pathPrefix}<user>`;
		}

		return match;
	});
}
